// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { GET_POLICIES_FOR_ANALYTICS } from "./action";

export function canGetPoliciesForAnalytics(scope: Scope): boolean {
  return scope.iamActions.includes(GET_POLICIES_FOR_ANALYTICS);
}
